
<!-- 
 消息通知页
 1.进入消息通知页后，需要改tabName的标识，为当前页的
  -->
<template>
  <div>
    消息通知页
    <el-empty :image-size="200"></el-empty>
  </div>
</template>

<script>
// 导入vuex
import { mapState,mapMutations } from 'vuex';
export default {
    name:'messagePage',
    data() {
      return {
        
      }
    },
    created() {
      // 设置tabName值为2
      this.changeTabPaneName('2');
    },
    methods: {
      ...mapMutations(['changeTabPaneName'])
    },

}
</script>

<style>

</style>